import { render, staticRenderFns } from "./checkbox-list.vue?vue&type=template&id=1dc86ddf"
import script from "./checkbox-list.vue?vue&type=script&lang=js"
export * from "./checkbox-list.vue?vue&type=script&lang=js"
import style0 from "./checkbox-list.vue?vue&type=style&index=0&id=1dc86ddf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports